import React, { Fragment, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

// application routes
import { appRoutes } from '../routes.router'

// guards controller
import GuardController from '../controller/Guard.controller'

// error page
import NotFound from '../../pages/404/NotFound.page'

// app loader
// import AppLoaderTemplate from '../../components/templates/loader/AppLoader.template'

const AppRouter: React.FC = () => {
  return (
    <div className='app'>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50'>
              <div className='text-center'>
                <div className='inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#007dfb]'></div>
                <p className='mt-4 text-gray-600 font-medium'>Loading...</p>
              </div>
            </div>
          }
        >
          <Routes>
            {appRoutes.map((route) =>
              route.nestedComponents ? (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<GuardController route={route} />}
                >
                  {route.nestedComponents.map((singleNest) => (
                    <Fragment key={singleNest.path}>
                      {singleNest.path === '/' ? (
                        <Route index element={<singleNest.component />} />
                      ) : singleNest.nestedComponents ? (
                        <Route path={singleNest.path} element={<singleNest.component />}>
                          {singleNest.nestedComponents.map((target) => (
                            <Fragment key={target.path}>
                              {target.path === '/' ? (
                                <Route index element={<target.component />} />
                              ) : (
                                <Route path={target.path} element={<target.component />}></Route>
                              )}
                            </Fragment>
                          ))}
                        </Route>
                      ) : (
                        <Route path={singleNest.path} element={<singleNest.component />}></Route>
                      )}
                    </Fragment>
                  ))}
                </Route>
              ) : (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<GuardController route={route} />}
                />
              ),
            )}

            {/** 404 - PAGE NOT FOUND ROUTE */}
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  )
}

export default AppRouter
